import color from '@mui/material/colors/purple';

export default function Style(theme) {
  const style = {
    button: {
        margin: '0 10px'
      },
    menuButton: {
      marginRight: 16,
    },
    title: {
      display: 'none',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: "1px 1px 1px 0",
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${32}px)`,
      width: '100%',
    },
    sectionDesktop: {
      display: 'flex',
    },
    yourImagesLink: {
      textDecoration: 'none',
      display: "block",
      margin: "0 5px"
    }
  }
    return style
}
